import TabPanel, { a11yProps } from './TabPanel'

export { a11yProps }
export default TabPanel
